var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container max-width-lg cd-timeline__container" },
    _vm._l(_vm.tweets, function(tweet) {
      return _c("div", { key: tweet.id, staticClass: "cd-timeline__block" }, [
        _vm._m(0, true),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "cd-timeline__content text-component" },
          [
            _c(
              "component-view",
              {
                attrs: {
                  id: tweet.id,
                  "error-message": "ツイートが読み込めませんでした"
                }
              },
              [_c("div", { staticClass: "spinner" })]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "flex justify-between items-center" }, [
              _c("span", { staticClass: "cd-timeline__date" }, [
                _vm._v(_vm._s(tweet.title))
              ])
            ])
          ],
          1
        )
      ])
    }),
    0
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "cd-timeline__img cd-timeline__img--movie" },
      [_c("img", { attrs: { src: "img/icon_baseball.svg", alt: "Cover" } })]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }